export const WINDOWS_SCROLLED_EVENT_STORE = 'WINDOW_SCROLLED_STORE';

export function setWindowScrolledEvent(scrollEvent: ScrollEventPayload) {
  return {
    type: WINDOWS_SCROLLED_EVENT_STORE,
    scrollEvent,
  };
}
